module.exports = __webpack_public_path__ + "753484a6e673a26fc55d13c74086aca4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mail.png
// module id = 1162
// module chunks = 0